import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, Link as RouterLink } from 'react-router-dom'

import { ReactComponent as LogoutSVG } from 'assets/images/logout.svg'
import LogoWhite from 'assets/images/logo-white.svg'

import { Tooltip } from 'components/tooltip'
import { Flex } from 'components/flex'

import { GlobalState } from 'store'
import { clearSessionData } from 'store/session/actions'

import { SidebarWrapper } from './styled'

import { Link, links } from './menu'
import { LOGIN_PAGE } from 'navigation/paths'
import { logout } from 'services/http/loginService'

export function Sidebar(): JSX.Element {
  const { t } = useTranslation(['common'])

  const dispatch = useDispatch()

  const { sidebarIsReduced } = useSelector(
    (state: GlobalState) => state.sidebar
  )

  function _renderNavLink(link: Link) {
    return (
      <Tooltip key={link.to} content={sidebarIsReduced ? t(link.title) : ''}>
        <NavLink to={link.to} exact={link.exact}>
          {link.icon && <link.icon />}
          <span>{t(link.title)}</span>
        </NavLink>
      </Tooltip>
    )
  }

  return (
    <SidebarWrapper isReduced={sidebarIsReduced}>
      <Flex
        direction="row"
        align="center"
        justify="center"
        style={{ width: '100%', height: 102 }}
      >
        <img
          src={LogoWhite}
          alt="Open Insurance"
          style={{ width: 'fit-content', margin: '0 auto' }}
        />
      </Flex>
      <nav>
        {links.map((link) =>
          link.children?.length ? (
            <>
              {_renderNavLink(link)}
              {link.children.map((childLink) => _renderNavLink(childLink))}
            </>
          ) : (
            _renderNavLink(link)
          )
        )}

        <RouterLink
          to={LOGIN_PAGE}
          style={{ marginTop: 'auto', marginBottom: 16 }}
          onClick={async () => {
            await logout();
            dispatch(clearSessionData())
          }}
        >
          <LogoutSVG />
          <span>Sair</span>
        </RouterLink>
      </nav>
    </SidebarWrapper>
  )
}
